import React, { Component } from 'react'
import { Row, Col, Cascader, Button, Spin, Table, Select, Input, Modal, Form, Upload, Popconfirm } from 'antd'
import { app, api, config } from "../../app"
import utils from "../../utils"

const Option = Select.Option
const FormItem = Form.Item

/**
 * 上传之前
 * @param file
 * @returns {boolean}
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('头像图片最大2MB!', 'warn')
    }
    return isLt2M
}

function getCategoryId (id, list) {
    for (let i = 0; i < list.length; i++) {
        if (id === list[i].id) {
            return [id]
        } else if (list[i].child) {
            for (let i2 = 0; i2 < list[i].child.length; i2++) {
                if (id === list[i].child[i2].id) {
                    return [list[i].id, id]
                }
            }
        }
    }
    return undefined
}

class HonorWallManage extends Component {
    constructor (props) {
        super(props)
        this.state = {
            default_category: [],
            categoryList: [],
            dataList: [],
            moldList: [],
            loading: true,
            data_loading: true,
            category_id: '',
            sel_mold: '0',
            search_val: '',
            edit_id: '',
            total: 0,
            page: 1,
            edit_visible: false,
            submit_loading: false,
            editInfo: {}
        }
    }

    async componentDidMount () {
        this._isMounted = true
        await this.moldource()
        await this.categorySource()
        await this.dataSource()
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    /**
     * 类型数据
     */
    categorySource = async () => {
        await this.setData({ loading: true })
        let { flag, data, msg } = await app.post(api.HSelectCategoryLists, {indexno: app.getData('indexno')})
        if (flag === 1) {
            await this.setData({
                categoryList: data,
                default_category: [data[0].id, data[0].child[0].id],
                category_id: data[0].child[0].id,
                loading: false
            })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 类目类型数据
     */
    moldource = async () => {
        await this.setData({ mold_loading: true })
        let { flag, data, msg } = await app.post(api.HSelectMoldLists)
        if (flag === 1) {
            await this.setData({ moldList: data, mold_loading: false })
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 删除
     */
    handleDel = async (id) => {
        app.alert('正在删除', 'loading')
        let { flag, msg } = await app.post(api.HAdminTypeDelete, {
            id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        })
        app.alertDestroy()
        if (flag === 1) {
            app.alert('删除成功', "success")
            const {dataList, page} = this.state
            if (dataList.length > 1) {
                await this.dataSource(page)
            } else {
                await this.dataSource(page > 1 ? (page - 1) : 1)
            }
        } else {
            app.alert(msg, "error")
        }
    }

    /**
     * 列表数据
     */
    dataSource = async (page = 1) => {
        await this.setData({ page, data_loading: true })
        let { category_id, sel_mold, search_val } = this.state
        let { flag, data, msg, count } = await app.post(api.HAdminTypeLists, {
            page,
            category_id,
            search_val,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
            search_type: 'searchform_name',
            mold: sel_mold
        })
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        if (page === this.state.page) {
            await this.setData({
                total: parseInt(count || 0),
                dataList: utils.addArrayKey(data),
                data_loading: false
            })
        }
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 类目变更
     * @param value
     * @returns {Promise<void>}
     */
    handleCategoryChange = async (value) => {
        await this.setData({ category_id: value[value.length - 1] })
        await this.dataSource(1)
    }

    /**
     * 打开编辑框
     */
    handleOpenEditModal = (info) => {
        const state = { edit_visible: true }
        if (info) {
            state.edit_id = info.id
            info.category_id = getCategoryId(info.category_id, this.state.categoryList)
            state.editInfo = info
        }
        this.setData(state)
    }

    /**
     * 关闭编辑框
     * @returns {Promise<void>}
     */
    handleCloseEditModal = async () => {
        await this.setData({edit_visible: false, edit_id: null, editInfo: {}})
        this.props.form.resetFields()
    }

    /**
     * 提交编辑
     * @param e
     */
    handleEdit = (e) => {
        e.preventDefault()
        this.props.form.validateFieldsAndScroll(async (err, values) => {
            if (!err) {
                if (this.state.submit_loading) return
                await this.setData({ submit_loading: true })
                let { edit_id } = this.state
                let urls = []
                for (let i = 0; i < values.img.length; i++) {
                    let response = values.img[i].response
                    if (response && response.flag === 1) {
                        urls.push(response.data.url)
                    }
                }
                values.img = urls[0]
                values.indexno = app.getData('indexno')
                values.account = app.getData('account')
                values.category_id = values.category_id[values.category_id.length - 1]
                let res = { msg: '发生错误' }, s_msg = ''
                if (edit_id) {
                    values.id = edit_id
                    res = await app.post(api.HAdminTypeEdit, values)
                    s_msg = '编辑成功'
                } else {
                    res = await app.post(api.HAdminTypeAdd, values)
                    s_msg = '添加成功'
                }
                const state = { submit_loading: false }
                if (res.flag === 1) {
                    app.alert(s_msg, 'success')
                    await this.setData(state)
                    await this.handleCloseEditModal()
                } else {
                    app.alert(res.msg, 'error')
                    await this.setData(state)
                }
                await this.dataSource()
            }
        })
    }

    render () {
        let { getFieldDecorator, getFieldValue } = this.props.form,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 10, offset: 1 },
            },
            {
                default_category, categoryList, moldList, dataList, data_loading, loading, total, page, edit_visible,
                edit_id, editInfo, submit_loading
            } = this.state,
            up_img = getFieldValue('img'),
            up_disabled = up_img && up_img.length >= 1,
            columns = [
                {
                    title: '排序',
                    dataIndex: 'order',
                    key: 'order',
                    width: '10%',
                    render: (o1, o2, o3) => (page - 1) * 20 + (o3 + 1)
                },
                {
                    title: '图片',
                    dataIndex: 'img',
                    key: 'img',
                    width: '20%',
                    render: (text) => {
                        return (<div className="hwmt-img">
                            <img src={config.imgUrl + text} alt="图片"/>
                        </div>)
                    },
                },
                {
                    title: '名称',
                    dataIndex: 'name',
                    key: 'name',
                    width: '25%'
                },
                {
                    title: '类型',
                    dataIndex: 'mold',
                    key: 'mold',
                    width: '15%',
                },
                {
                    title: '创建时间',
                    dataIndex: 'created_at',
                    key: 'created_at',
                    width: '15%',
                },
                {
                    title: '操作',
                    dataIndex: 'id',
                    key: 'id',
                    width: '15%',
                    render: (id, record) => {
                        return (
                            <div>
                                <Button type="primary" size="small"
                                        onClick={() => this.handleOpenEditModal(record)}>修改</Button>
                                <Popconfirm
                                    title="确认删除吗？"
                                    onConfirm={() => this.handleDel(id)}
                                >
                                    <Button type="danger" size="small" style={{ marginLeft: 10 }}>删除</Button>
                                </Popconfirm>
                            </div>
                        )
                    }
                },
            ]
        return (
            <div className="honor-wall-manage">
                <div className="hwm-title">荣誉设定</div>
                {
                    loading ? (<div style={{ textAlign: 'center', padding: '20px 0' }}><Spin size="large"/></div>) : (
                        <div className="hwm-c">
                            <Row className="hwm-btns" type="flex" justify="space-between" align="middle">
                                <Col>
                                    <Cascader fieldNames={{ label: 'name', value: 'id', children: 'child' }}
                                              defaultValue={default_category} options={categoryList}
                                              displayRender={label => label.join(' -> ')} expandTrigger="hover"
                                              style={{ width: '14rem' }} allowClear={false}
                                              onChange={this.handleCategoryChange} placeholder="选择类型"/>
                                    <Select style={{ margin: '0 1rem', width: '10rem' }} placeholder="选择荣誉类目"
                                            defaultValue="0" onChange={async value => {
                                                await this.setData({ sel_mold: value })
                                                await this.dataSource(1)
                                            }}>
                                        <Option value="0">全部</Option>
                                        {
                                            moldList.map((m, i) => {
                                                return (
                                                    <Option key={i} value={m.value + ''}>{m.name}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                    <Input.Search
                                        placeholder="关键词搜索"
                                        enterButton
                                        style={{ width: '14rem' }}
                                        onSearch={async value => {
                                            await this.setData({ search_val: value })
                                            await this.dataSource(1)
                                        }}
                                    />
                                </Col>
                                <Col>
                                    <Button type="primary" onClick={() => this.handleOpenEditModal()}>添加荣誉</Button>
                                </Col>
                            </Row>
                            <div className="hwm-content">
                                <Table
                                    columns={columns}
                                    locale={app.tbLocale(data_loading)}
                                    loading={data_loading}
                                    dataSource={dataList}
                                    scroll={{ y: 'calc(100vh - 310px)' }}
                                    pagination={{
                                        current: page,
                                        pageSize: 20,
                                        total: total,
                                        showTotal: (t) => `总数量：${t}`,
                                        onChange: this.dataSource
                                    }}
                                    size="small"
                                    className="table-odd-even-row"
                                />
                            </div>
                        </div>
                    )
                }
                <Modal
                    visible={edit_visible}
                    footer={null}
                    title={edit_id ? '编辑荣誉类目' : '添加荣誉类目'}
                    maskClosable={false}
                    width='60%'
                    bodyStyle={{ height: '80vh', overflow: 'auto' }}
                    onCancel={() => this.handleCloseEditModal()}
                >
                    <Form onSubmit={this.handleEdit}>
                        <FormItem
                            {...formItemLayout}
                            label="分类"
                        >{getFieldDecorator('category_id', {
                            initialValue: edit_id ? editInfo.category_id : undefined,
                            rules: [{ required: true, message: '请选择分类!' }],
                        })(
                            <Cascader expandTrigger="hover" fieldNames={{ label: 'name', value: 'id', children: 'child' }} options={categoryList} placeholder="选择类目"/>
                        )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="类目类型"
                        >{getFieldDecorator('mold', {
                            initialValue: edit_id ? editInfo.mold_id : undefined,
                            rules: [{ required: true, message: '请选择类目类型!' }],
                        })(
                            <Select style={{ width: '100%' }} placeholder="选择">
                                {
                                    moldList.map((m, i) => {
                                        return (
                                            <Option key={i} value={m.value + ''}>{m.name}</Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="类目名称"
                        >{getFieldDecorator('name', {
                            initialValue: edit_id ? editInfo.name : null,
                            rules: [{ required: true, message: '请输入类目名称!' }],
                        })(
                            <Input/>
                        )}
                        </FormItem>
                        <FormItem
                            labelCol={{ span: 6 }}
                            wrapperCol={{ span: 17, offset: 1 }}
                            label="上传图片"
                        >
                            {getFieldDecorator("img", {
                                valuePropName: 'fileList',
                                getValueFromEvent: e => {
                                    if (Array.isArray(e)) {
                                        return e
                                    }
                                    return e && e.fileList
                                },
                                rules: [
                                    { required: true, message: '请上传图片!' },
                                    { type: 'array', max: 1, message: '最多上传一张图片!' },
                                ],
                                initialValue: edit_id && editInfo.img ? [{
                                    uid: '-1',
                                    status: 'done',
                                    response: {
                                        flag: 1,
                                        data: {
                                            url: editInfo.img
                                        }
                                    },
                                    name: "图片",
                                    thumbUrl: config.imgUrl + editInfo.img
                                }] : []
                            })(
                                <Upload
                                    accept='image/jpeg, image/jpg, image/png'
                                    action={config.serverUrl + api.ImageUpload}
                                    listType="picture"
                                    beforeUpload={beforeUpload}
                                    data={{
                                        token: app.getData('token'),
                                        indexno: app.getData('indexno'),
                                        account: app.getData('account'),
                                        upload_type: 'ppe'
                                    }}
                                    name="image"
                                    disabled={up_disabled}
                                    className="upload-list-inline"
                                >
                                    <Button disabled={up_disabled}>上传图片</Button>
                                </Upload>
                            )}
                        </FormItem>
                        <FormItem
                            {...formItemLayout}
                            label="描述"
                        >{getFieldDecorator('descript', {
                            initialValue: edit_id ? editInfo.descript : null,
                        })(
                            <Input.TextArea rows={12}/>
                        )}
                        </FormItem>
                        <FormItem
                            wrapperCol={{ span: 10, offset: 7 }}
                        >
                            <Button type="primary" htmlType="submit" loading={submit_loading} block>提交</Button>
                        </FormItem>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default Form.create()(HonorWallManage)



// WEBPACK FOOTER //
// ./src/routes/grade/HonorWallManage.jsx